import React from "react";

import { DatePicker, ErrorMessage, TextField } from "widgets";
import { recalculateSellingPrice } from "utils/priceCalculation";

import styles from "./NewVersionPackageDetails.module.scss";

const handleDiscountChange = (event, setFieldValue) => {
  const value = event.target.value;
  const percentageFlag = value.includes("%");

  setFieldValue("discount_value", value);
  setFieldValue("is_percentage", percentageFlag);
};

const NewVersionPackageDetails = ({
  name,
  display_name,
  description,
  start_selling_date,
  end_selling_date,
  listed_price,
  selling_price,
  discount_value,
  is_percentage,
  errors,
  setFieldValue,
}) => {
  return (
    <div className={styles.mainContainer}>
      <div className={styles.packageDetailsContainer}>
        <div className={styles.fields}>
          <span className={styles.title}>Internal Package Name</span>
          <span className={styles.value}>{name}</span>
        </div>
        <div className={styles.description}>
          <span className={styles.title}>Package Description</span>
          <textarea
            name="description"
            value={description}
            onChange={(event) =>
              setFieldValue("description", event.target.value)
            }
            className={styles.descriptionTextField}
          />
          {errors && errors.description && (
            <ErrorMessage>{errors.description}</ErrorMessage>
          )}
        </div>
      </div>
      <div className={styles.packageOtherDetailsContainer}>
        <div className={styles.versionDisplayName}>
          <span className={styles.title}>Version Display Name</span>
          <TextField
            name="version display name"
            value={display_name}
            onChange={(event) =>
              setFieldValue("display_name", event.target.value)
            }
          />
          {errors && errors.display_name && (
            <ErrorMessage>{errors.display_name}</ErrorMessage>
          )}
        </div>
        <div className={styles.flexContainer}>
          <div className={styles.fields}>
            <span className={styles.title}>Start Selling Date</span>
            <DatePicker
              value={start_selling_date}
              onChange={(date) => setFieldValue("start_selling_date", date)}
              minDate={new Date()}
            />
            {errors && errors.start_selling_date && (
              <ErrorMessage>{errors.start_selling_date}</ErrorMessage>
            )}
          </div>
          <div className={styles.fields}>
            <span className={styles.title}>End Selling Date</span>
            <DatePicker
              value={end_selling_date}
              onChange={(date) => setFieldValue("end_selling_date", date)}
              minDate={new Date()}
            />
            {errors && errors.end_selling_date && (
              <ErrorMessage>{errors.end_selling_date}</ErrorMessage>
            )}
          </div>
        </div>
        <div className={styles.flexContainer}>
          <div className={styles.fields}>
            <span className={styles.title}>Default Price</span>
            <TextField
              name="listed_price"
              value={listed_price}
              onChange={(event) =>
                setFieldValue("listed_price", event.target.value)
              }
            />
            {errors && errors.price && (
              <ErrorMessage>{errors.listed_price}</ErrorMessage>
            )}
          </div>
          <div className={styles.fields}>
            <span className={styles.title}>Default Discount</span>
            <TextField
              name="discount_value"
              value={discount_value}
              onChange={(event) =>
                handleDiscountChange(event, setFieldValue)
              }
            />
            {errors && errors.discount_value && (
              <ErrorMessage>{errors.discount_value}</ErrorMessage>
            )}
          </div>
          <div className={styles.fields}>
            <span className={styles.title}>Selling Price</span>
            <TextField
              name="selling_price"
              value={recalculateSellingPrice(listed_price, discount_value)}
              disabled
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewVersionPackageDetails;
